import React, { useState, useEffect } from "react";
import { Text, Warning } from "../../formitems/Index";
import { Select } from "antd";
import { ConsoleSqlOutlined, LeftOutlined } from "@ant-design/icons";
import DatePicker from "react-datepicker";
import moment from "moment";
import { storage } from "../../../Firebase/firebase";
import firebase from "../../../Firebase/firebase";
import dateFormat from "dateformat";
import "./AddQualification.css";
import { useQuery, useMutation } from "@apollo/client";
import {
  Add_Qualifications,
  AllQualificationQuery,
  Add_Qualify,
  getClientId,
  get_Crew_Fleets,
  Add_Qualify_Replace,
  exist_Qualification,
} from "./CrewQueries/UploadQualification";
import Iframe from "react-iframe";
import "../../../assets/styles/custom/components/dashboard/Crew.scss";
const AddQualification = ({
  id,
  crewid,
  closeForm,
  Qualification_View_Query,
  toggle,
  validate,
  Qualification_Record_Query,
}) => {
  const [dropdown2, setdropdown2] = useState("");
  const [dropdown3, setdropdown3] = useState("");
  const [Issuedates, setIssuedates] = useState("");
  const [expiryDate, setexpiryDate] = useState("");
  const [document, setDocument] = useState("");
  const [isuue, setisuue] = useState("");
  const [caption1, setCaption1] = useState("");
  const [caption2, setCaption2] = useState("");
  const [caption3, setCaption3] = useState("");
  const [data1, setdata1] = useState("");
  const [data2, setdata2] = useState("");
  const [data3, setdata3] = useState("");
  const [documentNumber, setdocumentNumber] = useState("");
  const [issueUpto, setissueUpto] = useState("");
  const [validUpto, setvalidUpto] = useState("");
  const [issueAuthority, setissueAuthority] = useState("");
  const [image, setImage] = useState(null);
  const [togle, setTogle] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [url, setUrl] = useState("");
  const [disabled, setdisabled] = useState(false);
  const time = moment(Issuedates).format("YYYY/MM/DD");
  const issueDate = new Date(time);
  const dates = moment(expiryDate).format("YYYY/MM/DD");
  const vaidDate = new Date(dates);
  const [users, setusers] = useState({});
  const [crew, setcrew] = useState("");
  const [qid, setqid] = useState("");
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);

  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: getQualificationss } = useQuery(Add_Qualifications, {
    variables: { id: getclient?.aatmsv4_users[0]?.client.clientsid },
  });
  const { data: getcrewFleets } = useQuery(get_Crew_Fleets, {
    variables: { id: users?.token?.claims?.user_id },
  });

  const { data: existqualificationCheck } = useQuery(exist_Qualification, {
    variables: {
      id: dropdown2[0],
      crewId: getcrewFleets?.aatmsv4_crews[0]?.crewid,
    },
  });
  const { data: allQualifications } = useQuery(AllQualificationQuery, {
    variables: {
      id: dropdown2[0],
      clientid: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const [Add_Qualificationsss, { data: adds }] = useMutation(Add_Qualify, {
    refetchQueries: [
      {
        query: Add_Qualifications,
        variables: { id: getclient?.aatmsv4_users[0]?.client.clientsid },
      },
      {
        query: Qualification_Record_Query,
        variables: { crewid: crewid, active: true, validate: false, id: id },
      },
      {
        query: Qualification_Record_Query,
        variables: { crewid: crewid, active: false, validate: false, id: id },
      },
      {
        query: Qualification_View_Query,
        variables: {
          id: existqualificationCheck?.aatmsv4_qualificationrecords[0]?.qrid,
        },
      },
    ],
  });

  console.log(
    existqualificationCheck?.aatmsv4_qualificationrecords[0]?.document + "Jha"
  );

  const [Add_QualificationReplace, { data: addss }] = useMutation(
    Add_Qualify_Replace,
    {
      refetchQueries: [
        {
          query: Add_Qualifications,
          variables: { id: getclient?.aatmsv4_users[0]?.client.clientsid },
        },
        {
          query: Qualification_Record_Query,
          variables: { crewid: crewid, active: true, validate: false, id: id },
        },
        {
          query: Qualification_Record_Query,
          variables: { crewid: crewid, active: false, validate: false, id: id },
        },
        {
          query: Qualification_View_Query,
          variables: {
            id: existqualificationCheck?.aatmsv4_qualificationrecords[0]?.qrid,
          },
        },
      ],
    }
  );
  var check =
    dropdown2[0] ===
      existqualificationCheck?.aatmsv4_qualificationrecords[0]?.qid &&
    dropdown2 !== "";
  const Option = Select.Option;
  // const types = ["application/pdf"];
  const handChange = (e) => {
    const file = e.target.files[0];
    let name = file.name;
    var upld = name.split(".").pop();
    if (upld === "pdf") {
      if (file) {
        // const fileType = file["type"];
        const fileType = file;
        if (fileType) {
          setError("");
          setImage(file);
          setUrl("");
        } else {
          setError("Error:Please select an pdf to upload");
        }
      }
    } else {
      setError("Error:Please upload a pdf!");
    }
  };
  const handleUpdate = () => {
    if (image) {
      setdisabled(true);
      const uploadTask = storage
        .ref(
          `${getclient?.aatmsv4_users[0]?.client?.clientname}/qualification records/${dropdown2[1]}_${users?.token?.claims?.user_id}`
        )
        .put(image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progress);
        },
        (error) => {
          setError(error);
          setdisabled(false);
        },
        () => {
          storage
            .ref(
              `${getclient?.aatmsv4_users[0]?.client?.clientname}/qualification records/`
            )
            .child(`${dropdown2[1]}_${users?.token?.claims?.user_id}`)
            .getDownloadURL()
            .then((url) => {
              setUrl(url);
              setProgress(0);
              setdisabled(false);
            });
        }
      );
    } else {
      setError("Error please choose a PDF to upload");
    }
  };
  const emptyState = () => {
    setCaption1("");
    setCaption2("");
    setCaption3("");
    setisuue("");
    setDocument("");
    setdocumentNumber("");
    setissueAuthority("");
    setvalidUpto("");
    setissueUpto("");
    setdata1("");
    setdata2("");
    setdata3("");
    setexpiryDate("");
    setIssuedates("");
    setUrl("");
    check = undefined;
    setImage("");
    setdropdown2("");
    setdropdown3("");
    closeForm();
    setTogle(false);
  };
  const add = () => {
    Add_Qualificationsss({
      variables: {
        id: getclient?.aatmsv4_users[0]?.client.clientsid,
        clientname: getclient?.aatmsv4_users[0]?.client.clientname,
        crewId: getcrewFleets?.aatmsv4_crews[0]?.crewid,
        data1: caption1,
        data2: caption2,
        data3: caption3,
        catagory: allQualifications?.aatmsv4_qualifications[0]?.category,
        SubCatagory: allQualifications?.aatmsv4_qualifications[0]?.subcategory,
        manager1: allQualifications?.aatmsv4_qualifications[0]?.managersid1,
        manager2: allQualifications?.aatmsv4_qualifications[0]?.managersid2,
        manager3: allQualifications?.aatmsv4_qualifications[0]?.managersid3,
        qcode: allQualifications?.aatmsv4_qualifications[0]?.qcode,
        qid: allQualifications?.aatmsv4_qualifications[0]?.qid,
        qualification:
          allQualifications?.aatmsv4_qualifications[0]?.qualification,
        caption1: allQualifications?.aatmsv4_qualifications[0]?.caption1,
        caption2: allQualifications?.aatmsv4_qualifications[0]?.caption2,
        caption3: allQualifications?.aatmsv4_qualifications[0]?.caption3,
        documentNumber: document,
        issueAuthority: isuue,
        issuedate: Issuedates,
        expirydate: expiryDate,
        document: url,
      },
    });
  };
  const replace = () => {
    Add_QualificationReplace({
      variables: {
        id: existqualificationCheck?.aatmsv4_qualificationrecords[0]?.qrid,
        documentNumber: documentNumber,
        issueDate: issueUpto,
        validDate: validUpto,
        issueAuthority: issueAuthority,
        data1: data1,
        data2: data2,
        data3: data3,
        document: url,
      },
    });
  };

  return (
    // <div
    //   className="toggle-form-container"
    //   style={{ width: "40vw", margin: "auto" }}
    // >
    <div className="qualificationPage">
      <div className="addQualification__form qualificationPage__left">
        <div
          style={check === true ? { display: "none" } : { display: "block" }}
        >
          <div>
            <div className="addQualification__form--title">
              <span
                className="client-back"
                onClick={() => {
                  emptyState();
                }}
              >
                {<LeftOutlined />} Qualifications
              </span>
              <p>Add New Qualifications</p>
            </div>
            <Text
              title="Crew Name"
              disabled
              value={getcrewFleets?.aatmsv4_crews[0]?.name}
            />
            <div>
              <Select
                value={
                  dropdown2[1]
                    ? `${dropdown2[1]} : ${dropdown2[2]}`
                    : "Select your Qualification"
                }
                onChange={(e) => setdropdown2(e)}
              >
                {getQualificationss?.aatmsv4_qualifications?.map((el, i) => (
                  <Option
                    key={el?.qid}
                    value={[el?.qid, el?.qcode, el.qualification]}
                  >
                    {el?.qcode}: {el?.qualification}
                  </Option>
                ))}
              </Select>
            </div>
            <div>
              <Text
                placeholder="Document Number"
                title="Document Number"
                value={document}
                onChange={(e) => setDocument(e.target.value)}
              />
              <Text
                placeholder="Issuing Authority"
                value={isuue}
                title="Issuing Authority"
                onChange={(e) => setisuue(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption1}
                value={caption1}
                onChange={(e) => setCaption1(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption2}
                value={caption2}
                onChange={(e) => setCaption2(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption3}
                value={caption3}
                onChange={(e) => setCaption3(e.target.value)}
              />
              <span>
                {/* Issue Date:<b>{Issuedates ? Issuedates : null}</b> */}
                Issue Date:
              </span>
              <br />
              <DatePicker
                placeholderText="Select a date"
                value={Issuedates ? Issuedates : null}
                onChange={(date) => setIssuedates(dateFormat(date, "isoDate"))}
              />
              <br />
              <span>Expiry Date:</span>
              <br />
              <DatePicker
                placeholderText="Select a date"
                value={expiryDate ? expiryDate : null}
                onChange={(date) => setexpiryDate(dateFormat(date, "isoDate"))}
              />
              <br /> <br />
              <input
                type="file"
                accept="application/pdf"
                style={{ backgroundColor: "beige", borderRadius: "25px" }}
                onChange={handChange}
                className="file-input"
              />
              <span style={{ color: "red" }}>{error}</span>
              {/* <br /> */}
              {url ? (
                <div>
                  <a style={{ color: "orange" }} href={url} target="_blank">
                    View and Download File
                  </a>
                  <br />
                </div>
              ) : null}
              {}
              {!url ? (
                <div>
                  <button
                    disabled={disabled}
                    className="btn submit-button"
                    onClick={handleUpdate}
                  >
                    {progress !== 0 ? "Saving..." : "Save"}
                  </button>
                  <button
                    className="btn cancel-button"
                    onClick={() => {
                      emptyState();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              ) : null}
            </div>

            {url ? (
              <div>
                <button
                  className="submit-button"
                  onClick={() => {
                    add();
                    emptyState();
                  }}
                >
                  Submit
                </button>
                <button
                  className="cancel-button"
                  onClick={() => {
                    emptyState();
                  }}
                >
                  Cancel
                </button>
              </div>
            ) : null}
          </div>
        </div>
        <div>
          <div
            style={
              check === false || togle
                ? { display: "none" }
                : { display: "block" }
            }
          >
            <div style={{ textAlign: "center" }}>
              <Warning
                title="Qualification Already Exist:"
                style={{ fontSize: "36px" }}
              />
              <div>
                <span
                  style={{
                    border: "1px solid #e2d6d6",
                    width: "100%",
                    display: "grid",
                  }}
                >
                  Crew Name:{" "}
                  <b>
                    {
                      existqualificationCheck?.aatmsv4_qualificationrecords[0]
                        ?.crew?.name
                    }
                  </b>
                </span>
                <br />
                <span
                  style={{
                    border: "1px solid #e2d6d6",
                    width: "100%",
                    display: "grid",
                  }}
                >
                  Aircraft Name:{" "}
                  <b>
                    {
                      existqualificationCheck?.aatmsv4_qualificationrecords[0]
                        ?.crew?.fleet?.aircraft
                    }
                  </b>
                </span>
                <br />
                <span
                  style={{
                    border: "1px solid #e2d6d6",
                    width: "100%",
                    display: "grid",
                  }}
                >
                  Document Number:{" "}
                  <b>
                    {
                      existqualificationCheck?.aatmsv4_qualificationrecords[0]
                        ?.documentnumber
                    }
                  </b>
                </span>
                <br />
                <span
                  style={{
                    border: "1px solid #e2d6d6",
                    width: "100%",
                    display: "grid",
                  }}
                >
                  Valid Upto:{" "}
                  <b>
                    {
                      existqualificationCheck?.aatmsv4_qualificationrecords[0]
                        ?.validdate
                    }
                  </b>
                </span>
                <br />
              </div>
              <div>
                <img
                  width="500px"
                  src={
                    existqualificationCheck?.aatmsv4_qualificationrecords[0]
                      ?.document
                  }
                  alt=""
                />
              </div>
              <Warning
                title="THE ABOVE QUALIFICATION EXISTS IN RECORD ! DO YOU WANT TO REPLACE IT ?"
                style={{ fontSize: "36px" }}
              />
              <>
                <button
                  className="replace-submit-button"
                  onClick={() => {
                    setTogle(true);
                  }}
                >
                  Replace / Yes
                </button>
                <button
                  className="cancel-button"
                  onClick={() => {
                    emptyState();
                  }}
                >
                  No
                </button>
              </>
            </div>
          </div>
          <div style={togle ? { display: "block" } : { display: "none" }}>
            <div className="addQualification__form--title">
              <span
                className="client-back"
                onClick={() => {
                  emptyState();
                }}
              >
                {<LeftOutlined />} Qualifications
              </span>
              Replace Qualification
            </div>
            <div>
              <Text
                title="Crew Name"
                disabled
                value={getcrewFleets?.aatmsv4_crews[0]?.name}
              />
              <Text
                title="Quaification"
                value={dropdown2[2]}
                disabled
                onChange={(e) => setdropdown2(e.target.value)}
              />
              <Text
                placeholder="Document Number"
                title="Document Number"
                value={documentNumber}
                onChange={(e) => setdocumentNumber(e.target.value)}
              />
              <Text
                placeholder="Issuing Authority"
                value={issueAuthority}
                title="Issuing Authority"
                onChange={(e) => setissueAuthority(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption1}
                value={data1}
                onChange={(e) => setdata1(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption2}
                value={data2}
                onChange={(e) => setdata2(e.target.value)}
              />
              <Text
                placeholder="Enter Text"
                title={allQualifications?.aatmsv4_qualifications[0]?.caption3}
                value={data3}
                onChange={(e) => setdata3(e.target.value)}
              />
              <span>Issue Date:</span>
              <br />
              <DatePicker
                value={issueUpto ? issueUpto : null}
                onChange={(date) => setissueUpto(dateFormat(date, "isoDate"))}
              />
              <br />
              <br />
              <span>Expiry Date:</span>
              <br />
              <DatePicker
                value={validUpto ? validUpto : null}
                onChange={(date) => setvalidUpto(dateFormat(date, "isoDate"))}
              />
              <br />
              <br />
              <input
                type="file"
                accept="application/pdf,application/vnd.ms-excel"
                style={{
                  backgroundColor: "beige",
                  borderRadius: "25px",
                  overflow: "hidden",
                }}
                onChange={handChange}
                id="smallMarginTop"
                className="file-input"
              />

              {url ? (
                <div>
                  <a style={{ color: "orange" }} href={url} target="_blank">
                    View and Download File
                  </a>
                </div>
              ) : null}

              {!url ? (
                <div>
                  <button
                    disabled={disabled}
                    className="replace-submit-button"
                    onClick={progress !== 0 ? null : handleUpdate}
                  >
                    {progress !== 0 ? "Saving..." : "Save"}
                  </button>
                  <button
                    className="cancel-button"
                    onClick={() => {
                      emptyState();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              ) : null}
            </div>

            {url ? (
              <div>
                <button
                  className="submit-button"
                  onClick={() => {
                    replace();
                    emptyState();
                  }}
                >
                  Replace
                </button>
                <button
                  className="cancel-button"
                  onClick={() => {
                    emptyState();
                  }}
                >
                  Cancel
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div
        style={check === true ? { display: "none" } : { display: "block" }}
        className="qualificationPage__right"
      >
        <div>
          {url ? (
            <Iframe
              url={url}
              id="pdfId2"
              className="pdfClassname"
              display="initial"
              position="relative"
            />
          ) : null}
        </div>

        {/* {url ? (
            <Iframe
              url={url}
              id="pdfId"
              className="pdfClassname"
              display="initial"
              position="relative"
            />
          ) : null}
      
        <div
          className="qualificationPage__right"
          style={
            check === false || togle
              ? { display: "none" }
              : { display: "block" }
          }
        >
          {existqualificationCheck?.aatmsv4_qualificationrecords[0]
            ?.document ? (
            <Iframe
              url={
                existqualificationCheck?.aatmsv4_qualificationrecords[0]
                  ?.document
              }
              id="pdfId2"
              className="pdfClassname"
              display="initial"
              position="relative"
            />
          ) : null}
        </div> */}
      </div>
      <div
        className="qualificationPage__right"
        style={
          check === false || togle ? { display: "none" } : { display: "block" }
        }
      >
        {existqualificationCheck?.aatmsv4_qualificationrecords[0]?.document ? (
          <Iframe
            url={
              existqualificationCheck?.aatmsv4_qualificationrecords[0]?.document
            }
            id="pdfId3"
            className="pdfClassname"
            display="initial"
            position="relative"
          />
        ) : null}
      </div>
    </div>
  );
};
export default AddQualification;
